import '@/styles/fonts'
import '@/styles/global.css'

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { setTransport } from '@/api/client'
import { App } from '@/App'
import { applyStoredTheme } from '@/components/theme/useTheme'
import { env } from '@/config/env'
import { wireIdentityAuth } from '@/features/auth/identityAuth'
import { createQueryClient } from '@/lib/queryClient'

async function bootstrap(): Promise<void> {
  applyStoredTheme()
  // Literal env check (not `env.useMocks`) so Vite folds it at build time and the synthetic dataset
  // is dropped from production bundles entirely.
  if (import.meta.env.VITE_USE_MOCKS === 'true') {
    const { createMockServer } = await import('@/api/mock/mockTransport')
    setTransport(createMockServer(env.mockRole).transport)
  } else if (!env.authBypass) {
    wireIdentityAuth()
  }

  const container = document.getElementById('root')
  if (!container) throw new Error('#root element missing from index.html')
  createRoot(container).render(
    <StrictMode>
      <App queryClient={createQueryClient()} />
    </StrictMode>,
  )
}

void bootstrap()
